import {
  useQuery,
  useQueryClient,
  type UseQueryOptions,
} from '@tanstack/react-query';

import type { UserDetailsResponse } from './Login.model';
import { auth } from '../../api/Endpoints';
import { QUERY_KEYS } from '../../api/config';

export const useUserData = () => {
  const queryClient = useQueryClient();

  const { data: user } = useQuery({
    queryKey: [QUERY_KEYS.USER_DETAILS],
    queryFn: () => {
      // Return the cached data
      return (
        queryClient.getQueryData<UserDetailsResponse>([
          QUERY_KEYS.USER_DETAILS,
        ]) ?? null
      );
    },
  });

  return {
    user,
  };
};

export const useGetUserProfileQuery = (
  options?: Partial<UseQueryOptions<UserDetailsResponse, Error>>,
) => {
  return useQuery({
    ...options,
    queryKey: [QUERY_KEYS.USER_DETAILS],
    queryFn: async () => {
      const response = await auth.getUserProfile();
      return response.data;
    },
  });
};
